import React from 'react';
import { SearchIcon, UnlockIcon, HeartIcon, SunIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: <>
          <span className="text-terracotta font-semibold" data-id="element-1">Descubre</span> qué
          estás repitiendo
        </>,
    icon: <SearchIcon className="w-8 h-8 text-terracotta" strokeWidth={1.5} data-id="element-2" />
  }, {
    title: <>
          <span className="text-terracotta font-semibold" data-id="element-3">Suelta</span> lo que
          no es tuyo
        </>,
    icon: <UnlockIcon className="w-8 h-8 text-terracotta" strokeWidth={1.5} data-id="element-4" />
  }, {
    title: <>
          <span className="text-terracotta font-semibold" data-id="element-5">Reconecta</span>{' '}
          contigo
        </>,
    icon: <HeartIcon className="w-8 h-8 text-terracotta" strokeWidth={1.5} data-id="element-6" />
  }, {
    title: <>
          <span className="text-terracotta font-semibold" data-id="element-7">Deja</span> de vivir
          desde el pasado
        </>,
    icon: <SunIcon className="w-8 h-8 text-terracotta" strokeWidth={1.5} data-id="element-8" />
  }];
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14" data-id="element-11">
          {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center p-8 bg-white/50 rounded-2xl border border-dark/5" data-id="element-12">
              <div className="w-16 h-16 rounded-full bg-warmgold/20 flex items-center justify-center mb-6" data-id="element-13">
                {benefit.icon}
              </div>
              <h3 className="font-playfair text-2xl text-dark font-medium" data-id="element-14">
                {benefit.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}